// extracted by mini-css-extract-plugin
export default {"tabWrapper":"NavMenu_tabWrapper__plFsq","logo":"NavMenu_logo__PzhxD","toggle":"NavMenu_toggle__dlv3B"};